import React, { useCallback } from 'react';
import { Checkbox } from '@ontruck/orc';
import Calendar from './Calendar';
import Hour from './Hour';
import styledSchedule from './styled';

export const t = {
  label: 'Set up timer to trigger the task',
};

const Schedule = ({ showScheduling, setShowScheduling, date, handleChangeDate, className }) => {
  const handleCheckboxChange = useCallback(() => {
    setShowScheduling((current) => !current);
  }, [setShowScheduling]);

  return (
    <div className={className}>
      <div>
        <Checkbox label={t.label} checked={showScheduling} onChange={handleCheckboxChange} />
      </div>
      {showScheduling && (
        <div className="fields">
          <span>
            <Calendar value={date} setValue={handleChangeDate} />
          </span>
          <span>
            <Hour value={date} setValue={handleChangeDate} />
          </span>
        </div>
      )}
    </div>
  );
};

export default styledSchedule(Schedule);
